import React from "react";
import { cx } from "./utils";

const SectionCard = ({ title, subtitle, action, children, className = "", bodyClassName = "" }) => (
  <section className={cx("rounded-3xl border border-slate-200 bg-white shadow-sm", className)}>
    {(title || action) && (
      <div className="flex flex-col gap-3 border-b border-slate-100 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-lg font-semibold text-slate-950">{title}</h2>
          {subtitle ? <p className="mt-1 text-sm text-slate-500">{subtitle}</p> : null}
        </div>
        {action}
      </div>
    )}
    <div className={cx("p-5", bodyClassName)}>{children}</div>
  </section>
);

export default SectionCard;
